import { PlusCircleTwoTone } from '@ant-design/icons'
import { Space, Button } from 'antd'
import { useExternalLinkEditorContext } from '../ExternalLinkEditorContext'
import QuickLinkDropdownButton from './components/QuickLinkDropdownButton'

/** @private */
const ExternalLinkEditorButtons: React.FC = () => {
  const { disabled, add } = useExternalLinkEditorContext()
  return (
    <Space>
      <QuickLinkDropdownButton />
      <Button
        type="primary"
        icon={<PlusCircleTwoTone />}
        disabled={disabled}
        onClick={() => add()}
      >
        External Link
      </Button>
    </Space>
  )
}

export default ExternalLinkEditorButtons
